import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CartComponent} from './cart-component/cart.component';

const routes: Routes = [  {
  path: '',
  component: CartComponent,
  data: { breadcrumb: { skip: true} }
}
 ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CartRoutingModule { }
